import { Link } from "react-router-dom";
import { categories, regions, years, sortOptions } from "@/mocks/anime";

interface CategoryFilterProps {
  categoryId: string;
  region: string;
  year: string;
  sort: string;
  onRegionChange: (v: string) => void;
  onYearChange: (v: string) => void;
  onSortChange: (v: string) => void;
}

function ChipRow({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: string[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
      <span className="shrink-0 text-sm text-foreground-500 sm:w-12 sm:pt-1.5">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
              value === opt
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function CategoryFilter({
  categoryId,
  region,
  year,
  sort,
  onRegionChange,
  onYearChange,
  onSortChange,
}: CategoryFilterProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
        <span className="shrink-0 text-sm text-foreground-500 sm:w-12 sm:pt-1.5">分类</span>
        <div className="flex flex-wrap gap-2">
          <Link
            to="/category/all"
            className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors whitespace-nowrap ${
              categoryId === "all"
                ? "bg-secondary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900"
            }`}
          >
            全部
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors whitespace-nowrap ${
                cat.id === categoryId
                  ? "bg-secondary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900"
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="h-px bg-background-200"></div>

      <ChipRow label="地区" options={regions} value={region} onChange={onRegionChange} />

      <div className="h-px bg-background-200"></div>

      <ChipRow label="年份" options={years} value={year} onChange={onYearChange} />

      <div className="h-px bg-background-200"></div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <span className="shrink-0 text-sm text-foreground-500 sm:w-12">排序</span>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onSortChange(opt.value)}
              className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
                sort === opt.value
                  ? "bg-accent-500 text-foreground-950"
                  : "bg-background-100 text-foreground-600 hover:bg-accent-100 hover:text-accent-900"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}